export default {
  title: 'General Creation',
  content:
    'You can create works based on templates and flexibly adjust assets and parameters.',
  dco: {
    title: 'Dynamic Creative Optimization',
    content:
      'DCO creative is a production method that supports the ability of intelligent advertising. The creative produced can display different content for different audience. You can add alternative assets for each open positions, then apply the creative to your Mintegral campaign. Mintegral will select the best assets at each position according to the algorithm and combine them for a version to improve conversion.',
    tips: 'Usually used to describe dynamic creatives. In order to achieve the goal of optimizing creatives and increasing conversions, Mintegral will combine different creative elements for ad display based on machine learning.',
  },
  multi: {
    title: 'Edit Multi-Combination',
    content:
      'Variant creation is an efficient method for creating works for AB test. You can add multiple assets to the position to be adjusted and download all at once (up to 27).',
  },
  is_optimiz: {
    label: 'Feature Creation',
    yes: 'Support Feature Creation',
    no: 'Not Support Feature Creation',
  },
  emptyList: 'No Data',
  previewButtonText: 'Preview',
  editButtonText: 'Edit Version',
  createButtonText: 'Create Project',
  versionGuideText: 'versions',
  templateListHeaderText: {
    ProductInfo: 'Creative Concept Name and ID',
    VersionCount: 'Project Count',
    Network: 'Networks',
    NetworkTips: 'Configuration supports Mintegral only',
    Platform: 'Platform',
    Language: 'Language',
    Lastedittime: 'Last edit time',
    Creationtime: 'Delivery time',
    versionCreatedTime: 'Creation time',
    Options: 'Operations',
  },
  options: {
    version: 'Project Management',
    dco: 'Dco Version Management',
    multi: 'Version Management',
    preview: 'Preview',
    report: 'View Data',
  },
  order: {
    ascending: 'Ascending',
    descending: 'Descending',
  },
  search: 'Search',
  DatePicker: {
    Starttime: 'Start date',
    to: 'to',
    Endtime: 'End date',
  },
  empty: {
    NoResults: 'No Results',
    msg: 'Sorry, no eligible results were found. It is suggested to change to different search criteria.',
    back: 'Back',
    text: 'The version list is empty',
    textTip: 'Click the button below to create a new version',
    listEmpty: 'No Results',
    listEmptyMsg: 'This feature is not available, please contact',
    listEmptySubMsg: 'support@mindworks-creative.com for more information.',
  },
}
